const restaurantOffers = [
    {
        "id": "1",
        "offer": "80% off upto ₹150",
        "code":"try new",
    },
    {
        "id": "2",
        "offer": "Flat ₹50 off",
        "code":"Friday",
    },
    {
        "id": "3",
        "offer": "Flat ₹120 off",
        "code":"axis120 | Above 500",
    },
    {
        "id": "4",
        "offer": "Flat ₹200 off",
        "code":"axis200 | Above 1000",
    },
]

export default restaurantOffers;